import { useEffect, useState } from 'react';
import { serviceService } from '../services/serviceService';
import type { ServiceUsage } from '../types/service.types';

export function useServiceUsage(serviceId: string | undefined) {
  const [data, setData] = useState<ServiceUsage | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!serviceId) {
      setIsLoading(false);
      return;
    }
    let cancelled = false;
    setIsLoading(true);
    setError(null);

    serviceService
      .getUsage(serviceId)
      .then((u) => {
        if (!cancelled) setData(u);
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(err instanceof Error ? err : new Error(String(err)));
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [serviceId]);

  return { data, isLoading, error };
}
